/* holy-density — DENSITY ENGINE controller (Block 1, 2026-07-03).
   Per-CONTAINED-AREA content-density dial: each [data-density-unit] resolves to a
   register d1 (direct-response) → d2 (balanced, today's default) → d3 (editorial)
   → d4 (refined) and receives the matching du-d* class. Registers only ever
   hide-in-DOM, swap to a short copy slot, or fold behind an expand — never delete.
   Resolution order (highest wins):
     1. page preview  — ?d=1..4 sets + persists (localStorage holy_density_preview;
                        ?d=0 / any non-1..4 value clears)
     2. editor lock   — data-density-lock="d1..d4" on the unit (section setting)
     3. profile       — assets/holy-density-profiles.json → profiles[template][unit]
     4. default d2    — pixel-identical to today
   Fingerprint: window.HOLY_DENSITY = {template, preview, units:{id:register}} +
   dataLayer event 'holy_density'. On a successful /cart/add.js the current
   register mix rides dataLayer event 'holy_atc_density' (read-only fetch tap —
   no new pipes). AXIS later dials profiles against CVR/AOV/subscribe/book. */
(function () {
  'use strict';
  var REG = ['d1', 'd2', 'd3', 'd4'];
  var DEFAULT_REG = 'd2';
  var me = document.querySelector('script[data-holy-density]');
  var template = (me && me.getAttribute('data-template')) || '';
  var profilesUrl = (me && me.getAttribute('data-profiles')) || '';

  /* ── preview override: ?d=1..4 sets + persists; anything else on ?d= clears ── */
  var preview = null;
  try {
    var q = new URLSearchParams(window.location.search).get('d');
    if (q !== null) {
      if (/^[1-4]$/.test(q)) localStorage.setItem('holy_density_preview', 'd' + q);
      else localStorage.removeItem('holy_density_preview');
    }
    var stored = localStorage.getItem('holy_density_preview');
    if (stored && REG.indexOf(stored) !== -1) preview = stored;
  } catch (e) { /* storage unavailable — no preview */ }

  var lastProfile = null;

  function resolveRegister(el, profile) {
    var reg = DEFAULT_REG;
    var id = el.getAttribute('data-density-unit');
    if (profile && REG.indexOf(profile[id]) !== -1) reg = profile[id];
    var lock = el.getAttribute('data-density-lock');
    if (lock && REG.indexOf(lock) !== -1) reg = lock;   /* editor lock beats profile */
    if (preview) reg = preview;                          /* full-page preview beats all */
    return reg;
  }

  function apply(profile, pushEvent) {
    lastProfile = profile;
    var units = {};
    var els = document.querySelectorAll('[data-density-unit]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var reg = resolveRegister(el, profile);
      el.classList.remove('du-d1', 'du-d2', 'du-d3', 'du-d4');
      el.classList.add('du-' + reg);
      units[el.getAttribute('data-density-unit')] = reg;
    }
    window.HOLY_DENSITY = { template: template, preview: preview, units: units };
    if (pushEvent) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'holy_density',
        density_template: template,
        density_preview: preview || '',
        density_units: units
      });
    }
  }

  function boot() {
    if (preview) { apply(null, true); return; } /* preview beats all — no fetch needed */
    if (!profilesUrl) { apply(null, true); return; }
    fetch(profilesUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var map = (json && json.profiles && json.profiles[template]) || null;
        apply(map, true);
      })
      .catch(function () { apply(null, true); });
  }

  /* ── collapse-to-expand toggle (register vocabulary c) — delegated ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.du-fold__btn');
    if (!btn) return;
    var fold = btn.closest('.du-fold');
    if (!fold) return;
    e.preventDefault();
    var open = fold.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── measurement tap: successful /cart/add.js carries the register mix.
     Read-only wrapper — original promise returned untouched. ── */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments);
      try {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        if (url.indexOf('/cart/add') !== -1) {
          p.then(function (r) {
            if (!r || !r.ok) return;
            var d = window.HOLY_DENSITY || { template: template, preview: preview, units: {} };
            var mix = { d1: 0, d2: 0, d3: 0, d4: 0 };
            for (var k in d.units) { if (mix[d.units[k]] !== undefined) mix[d.units[k]]++; }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'holy_atc_density',
              density_template: d.template,
              density_preview: d.preview || '',
              density_units: d.units,
              density_mix: mix
            });
          }, function () { /* swallow on the tap chain only */ });
        }
      } catch (e) { /* never interfere with the add path */ }
      return p;
    };
  }

  /* theme editor re-renders a section → re-resolve its units with the last profile */
  document.addEventListener('shopify:section:load', function () { apply(lastProfile, false); });

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
